/* eslint-disable lingui/text-restrictions */

import { openai } from "./client";

/*
const PROMPT = `You are an AI writing assistant specialized in writing copy for resumes.
Do not return anything else except the text you improved. It should not begin with a newline. It should not have any prefix or suffix text.
Improve the writing of the following paragraph and return three suggestions for improvement in list form in the language of the text. separate each suggestion with
the specific line "---" ;*/


// const PROMPT = `tu es un expert capable de rédiger les descriptions de missions pour un CV, spécifiquement adaptées à un intitulé d\'emploi donné.
// Pour chaque intitulé d\'emploi fourni, tu devras définir succinctement les trois missions clés associées à ce poste.
// Les descriptions des missions doivent être présentées sous forme de liste à puce, avec un maximum de 250 caractères par item.Voici l\'intitulé d\'emploi pour lequel j\'aimerais obtenir ces informations :Intitulé d\'emploi : {input}.
// Merci de fournir, en français,  les missions clés qui correspondent à cet intitulé d\'emploi, en veillant à ce que chaque description soit concise, précise, et utile pour enrichir un CV.:
// Sépare chacune des propositions par la ligne spécifique "---" ;

const PROMPT = `tu es un expert capable de rédiger les descriptions de formations acquises pour un CV
 fournir une description concise et percutante des matières clés abordés dans le diplôme {degree} en {field},délivré par {institution}.
 Cette description doit mettre en lumière les matières clés enseignées et l'approche pédagogique de {institution} .
 3 propositions d'un maximum de 300 caractères seront fournies en Français.Chacune des proposition,séparées par la ligne "---".
 les 3 propositions doivent être rédigées à la première personne sur un ton professionnel
 l'objectif final est d'ajouter une ligne formation sur le curriculum vitae de l'utilisateur :"

  Text: """{degree}{field}{institution}""";

Revised Text: """`;

export const improveDegree = async (degree,field,institution) => {
  const prompt = PROMPT
    .replace("{degree}", degree)
    .replace("{field}", field)
    .replace("{institution}", institution);


  const result = await openai().chat.completions.create({
    messages: [{ role: "user", content: prompt }],
    model: "gpt-4",
    max_tokens: 1000,
    temperature: 0,
    stop: ['"""'],
    n: 1,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI did not return any choices for your text.`);
  }

  return result.choices[0].message.content ?? text;
};

